import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroTramitacoesInternas extends Filtro {
    tipo = 'selecao';
    exibicao = 'autocomplete';

    get label() {
        return 'Tramitações Internas';
    }

    constructor(props) {
        super({ ...props, exibeTotalizadores: false });

        makeObservable(this, {
            opcoesSelect: computed,
            carregandoDadosComplementares: computed
        });
    }

    get opcoesSelect() {
        let opcoes = [];
        let processos = this.store.processosFiltrados;
        let valorOpcao;

        for (const registro of processos) {
            valorOpcao = this.getValorOpcao(registro);
            if (valorOpcao) {
                opcoes.push({
                    texto: (this.getDescricao(valorOpcao) || '').trim(),
                    icone: this.getIconeOpcao(registro, valorOpcao),
                    cor: this.getCorOpcao(registro, valorOpcao),
                    valor: valorOpcao
                });
            }
        }

        opcoes = opcoes.filter((opcao, index, self) => index === self.findIndex((o) => o.texto === opcao.texto));
        opcoes.sort(this.sort);

        return opcoes;
    }

    getValorOpcao(registro) {
        if (this.store.mapaMovimentacoesInternas) {
            const numeroProcesso = registro.processo.numeroCompleto.split(' - ')[1];
            return this.store.mapaMovimentacoesInternas[numeroProcesso];
        }
    }

    getDescricao(valor) {
        return valor ? valor.descricao : '';
    }

    equals(valor1, valor2) {
        return valor1 && valor2 && valor1.descricao && valor1.descricao.localeCompare(valor2.descricao) === 0;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoTramitacoesInternas;
    }

    renderCarregando() {
        return this.renderCircularProgress('tramitações internas dos processos');
    }
}
